import { useContext, useEffect } from 'react';
import { FILTERS_PROVIDER_QS_KEYS } from '../contexts';
import useQueryParams from 'components/hooks/useQueryParams';
import { useLocation } from 'react-router';

const useQueryStringPersist = ({ Context }) => {
  const {
    state: { selectedFilterSetId }
  } = useContext(Context);

  const location = useLocation();
  const { updateQueryParam } = useQueryParams();

  useEffect(() => {
    updateQueryParam(
      FILTERS_PROVIDER_QS_KEYS.FILTER_SET_ID,
      selectedFilterSetId
    );
  }, [selectedFilterSetId, location.pathname]);
};

export default useQueryStringPersist;
